import {useDefault} from '../../../../common/common';
import {ChargeType} from './charge.type.model';

export class RateCharge {
  type: ChargeType;
  amount: number;
  description: string
  text: string;
  includedInPrice: boolean;

  constructor(type: ChargeType, amount?: number, description?: string, text?: string, includedInPrice?: boolean) {
    this.type = type;
    this.amount = useDefault(amount, 0);
    this.description = useDefault(description, '');
    this.text = useDefault(text, '');
    this.includedInPrice = useDefault(includedInPrice, false);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/rate-charge.model.ts